import React from 'react';
import Img from 'react-image';
import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import { parseSanitizedHTML } from '../../utils/Helper';

import Loader from '../../components/Loader';

const GridItem = ({ content, length = 150, lazy }) => {
  return (
    <>
      <div className={`grid ${!content.thumbnail ? 'noImg' : ''}`}>
        <div className="grid__imgContainer">
          {content.thumbnail && (
            <Link to={content.url}>
              {lazy ? (
                <LazyLoad>
                  <Img
                    className="grid__imgContainer__img"
                    src={content.thumbnail}
                    alt={content.image_alt_text}
                    decode={false}
                    loader={<Loader />}
                    unloader={<span>X</span>}
                  />
                </LazyLoad>
              ) : (
                <img src={content.thumbnail} alt={content.image_alt_text} />
              )}
            </Link>
          )}
        </div>
        <div className="grid__content">
          <div className="grid__content__date">
            {content.displayPublishDate || content.content_publish_date}
          </div>
          {content.headline && (
            <div className="grid__content__title">
              <Link to={content.url}>{content.headline}</Link>
            </div>
          )}
          {content.abstract && (
            <div className="grid__content__desc">
              <Link to={content.url}>
                <p>{parseSanitizedHTML(content.abstract, length)}</p>
              </Link>
            </div>
          )}

          <div className="mf-detail__box-control">
            <Link to={content.url} className="mf-detail__btn-arrow" target="_blank">
              <span className="visually-hidden">もっと見る</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default GridItem;
